import { EstabelecimentoModel } from '../../estabelecimento.model';
import * as moment from 'moment';

export class RascAtividadesModel {
    geral: RascGeral;
    classificacaoTipoEstabelecimento: RascClassificacaoTipoEstabelecimento;
    // atividadePrincipal: RascAtividadePrincipal;
    // tipoestabelecimento: RascTipoEstabelecimento;
    codigosConvenios: RascConvenios[];
    horariosAtendimento: RascHorariosAtendimento[];
    niveisAtencao: RascNiveisAtencao[];
    contratoSUS: string;
    formaAcesso: string;
    sempreAberto: string;
    codigoTipoEstabelecimentoOutros: string;


    constructor(estabelecimento: EstabelecimentoModel) {
        /*this.montarAtividadePrincipal(estabelecimento);
        this.atividadesSecundarias = this.montarAtividadesSecundarias(estabelecimento);
        this.montarTipoestabelecimento(estabelecimento);*/
        this.montaCaracterizacaoGeral(estabelecimento);
    }

    private montaCaracterizacaoGeral(estabelecimento: EstabelecimentoModel) {
        this.montaClassificacaoTipoEstabelecimento(estabelecimento);
        this.contratoSUS = estabelecimento.caracterizacao.geral.possuiContratoSus;
        this.codigosConvenios = this.montarConvenios(estabelecimento);
        this.formaAcesso = estabelecimento.caracterizacao.geral.idFormaAcesso;
        // tslint:disable-next-line:max-line-length
        this.horariosAtendimento = estabelecimento.caracterizacao.geral.horariosAtendimento; // this.montarHorariosAtendimento(estabelecimento);
        this.niveisAtencao = this.montarNiveisAtencao(estabelecimento);
        this.sempreAberto = estabelecimento.caracterizacao.geral.sempreAberto;
        this.codigoTipoEstabelecimentoOutros = estabelecimento.caracterizacao.geral.codigoTipoEstabelecimentoOutros;
    }

    private montaClassificacaoTipoEstabelecimento(estabelecimento: EstabelecimentoModel) {
        // this.atividadesSecundarias = this.montarAtividadesSecundarias(estabelecimento);
        // this.montarAtividadePrincipal(estabelecimento);
        // this.montarTipoestabelecimento(estabelecimento);

        const classificacaoTipoEstabelecimento: RascClassificacaoTipoEstabelecimento = {
            atividadePrincipal: this.montarAtividadePrincipal(estabelecimento),
            atividadesSecundarias: this.montarAtividadesSecundarias_1(estabelecimento),
            tipoEstabelecimento: this.montarTipoestabelecimento(estabelecimento),
            codigoAtividadePrincipal: estabelecimento.caracterizacao.geral.idAtividadePrincipal,
            codigosAtividadesSecundarias: this.montarAtividadesSecundarias(estabelecimento)
        };
        this.classificacaoTipoEstabelecimento = classificacaoTipoEstabelecimento;
    }

    private montarAtividadesSecundarias(estabelecimento: EstabelecimentoModel): [] {
        const lista: [] = [];
        estabelecimento.caracterizacao.geral.atividadesSecundarias.forEach((item) => {
            // @ts-ignore
            lista.push(item.idAtividade);
        });
        return lista;
    }

    private montarAtividadesSecundarias_1(estabelecimento: EstabelecimentoModel): RascAtividadesSecundaria[] {
        const lista: RascAtividadesSecundaria[] = [];
        estabelecimento.caracterizacao.geral.atividadesSecundarias.forEach((item) => {
            lista.push({
                id: item.id,
                codigo: item.idAtividade,
                grupo: {
                    codigo: item.idGrupoAtividade,
                    conceito: 'Não Informado',
                    dataAtualizacao: moment().format('DD/MM/YYYY'),
                    descricao: item.descricaoGrupoAtividade,
                    id: item.idGrupoAtividade,
                },
                descricao: item.descricaoGrupoAtividade,
                conceito: 'Não Informado',
                dataAtualizacao: moment().format('DD/MM/YYYY'),
            });
        });
        return lista;
    }

    private montarAtividadePrincipal(estabelecimento: EstabelecimentoModel) {
        const atividadePrincipal: RascAtividadePrincipal = {
            id: estabelecimento.caracterizacao.geral.idGrupoAtividadePrincipal,
            codigo: estabelecimento.caracterizacao.geral.idAtividadePrincipal,
            descricao: estabelecimento.caracterizacao.geral.atividadePrincipal,
            conceito: 'Não Informado',
            dataAtualizacao: moment().format('DD/MM/YYYY'),
            grupo: {
                codigo: estabelecimento.caracterizacao.geral.idGrupoAtividadePrincipal,
                conceito: 'Não Informado',
                dataAtualizacao: moment().format('DD/MM/YYYY'),
                descricao: estabelecimento.caracterizacao.geral.grupoAtividadePrincipal,
                id: estabelecimento.caracterizacao.geral.idGrupoAtividadePrincipal,
            }
        };
        return atividadePrincipal;
    }

    private montarTipoestabelecimento(estabelecimento: EstabelecimentoModel) {
        // id: estabelecimento.caracterizacao.geral.idGrupoAtividadePrincipal,
        const tipoEstabelecimento: RascTipoEstabelecimento = {
            id: '',
            codigo: estabelecimento.caracterizacao.geral.idTipoEstabelecimento,
            descricao: estabelecimento.caracterizacao.geral.tipoEstabelecimento,
            conceito: 'Não Informado'
        };
        return tipoEstabelecimento;
    }

    private montarConvenios(estabelecimento: EstabelecimentoModel): [] {

        const lista: [] = [];
        estabelecimento.caracterizacao.geral.convenios.forEach((item) => {
            // @ts-ignore
            lista.push(item.idConvenio);
            /*lista.push({
                id: item.id,
                codigo: item.idConvenio,
                descricao: item.descricaoConvenio,
                dataAtualizacao: moment().format('DD/MM/YYYY'),
            });*/
        });
        return lista;
    }

    private montarHorariosAtendimento(estabelecimento: EstabelecimentoModel): RascHorariosAtendimento[] {
        // this.estabelecimento = estabelecimento.geral.;
        /* {
             "codigoDiaSemana": "01",
             "horarioFim": "string",
             "horarioInicio": "string"
         }*/
        console.log('montaCaracterizacaoGeral_1 =>', estabelecimento.caracterizacao);
        const lista: RascHorariosAtendimento[] = [];
        const diaSemana = ['domigo', 'segundafeira', 'tercafeira', 'quartafeira', 'quintafeira', 'sextafeira', 'sabado'];
        estabelecimento.caracterizacao.geral.horariosAtendimento.forEach((item) => {
            console.log('montarHorariosAtendimento =>', item);
            console.log(Object.keys(item));
            console.log(diaSemana);
            lista.push({
                codigoDiaSemana: item.codigoDiaSemana,
                horarioFim: item.horarioFim,
                horarioInicio: item.horarioInicio
            });
        });
        return lista;
    }

    private montarNiveisAtencao(estabelecimento: EstabelecimentoModel): RascNiveisAtencao[] {
        const lista: RascNiveisAtencao[] = [];
        estabelecimento.caracterizacao.geral.niveisAtencao.forEach((item) => {
            lista.push({
                codigoComplexidade: item.idComplexidade,
                codigoTipoAtividade: item.idTipo,
                codigoTipoGestao: item.idGestao
                /*id: item.id,
                gestao: {
                    codigo: item.idGestao,
                    descricao: item.descricaoGestao,
                    tipoAtividade: {
                        codigo: item.idTipo,
                        descricao: item.descricaoTipo,
                    }
                },
                tipoGestao: {
                    codigo: '',
                    descricao: ''
                }*/
            });
        });
        return lista;
    }
}

export interface RascGeral {
    classificacaoTipoEstabelecimento: RascClassificacaoTipoEstabelecimento;
    contratoSUS: string;
    codigosConvenios: [];
    formaAcesso: string;
    horariosAtendimento: RascHorariosAtendimento;
    niveisAtencao: RascNiveisAtencao;
    sempreAberto: string;
}

export interface RascClassificacaoTipoEstabelecimento {
    atividadePrincipal: RascAtividadePrincipal;
    atividadesSecundarias: RascAtividadesSecundaria[];
    tipoEstabelecimento: RascTipoEstabelecimento;
    codigoAtividadePrincipal: string;
    codigosAtividadesSecundarias: [];
}

export interface RascAtividadePrincipal {
    id: string;
    codigo: string;
    grupo: RascGrupo;
    descricao: string;
    conceito: string;
    dataAtualizacao: string;
}

export interface RascGrupo {
    codigo: string;
    conceito: string;
    dataAtualizacao: string;
    descricao: string;
    id: string;
}

export interface RascAtividadesSecundaria {
    id: string;
    codigo: string;
    grupo: RascGrupo;
    descricao: string;
    conceito: string;
    dataAtualizacao: string;
}

export interface RascTipoEstabelecimento {
    id: string;
    codigo: string;
    descricao: string;
    conceito: string;
}

export interface RascConvenios {
    id: string;
    codigo: string;
    descricao: string;
    dataAtualizacao: string;
}

export interface RascDiadaSemana {
    codigo: string;
    descricao: string;
}

export interface RascHorariosAtendimento {
    codigoDiaSemana: string;
    horarioFim: string;
    horarioInicio: string;
}

export interface RascGestao {
    codigo: string;
    descricao: string;
    tipoAtividade: RascTipoAtividade;
}

export interface RascTipoAtividade {
    codigo: string;
    descricao: string;
}

export interface RascTipoGestao {
    codigo: string;
    descricao: string;
}

export interface RascNiveisAtencao {
    /*id: string;
    gestao: RascGestao;
    tipoGestao: RascTipoGestao;*/
    codigoComplexidade: string;
    codigoTipoAtividade: string;
    codigoTipoGestao: string;
}
